var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3996 7.0001C13.3996 10.5347 10.5342 13.4001 6.99961 13.4001C3.46499 13.4001 0.599609 10.5347 0.599609 7.0001C0.599609 3.46548 3.46499 0.600098 6.99961 0.600098C10.5342 0.600098 13.3996 3.46548 13.3996 7.0001ZM7.79961 10.2001C7.79961 10.6419 7.44144 11.0001 6.99961 11.0001C6.55778 11.0001 6.19961 10.6419 6.19961 10.2001C6.19961 9.75827 6.55778 9.4001 6.99961 9.4001C7.44144 9.4001 7.79961 9.75827 7.79961 10.2001ZM6.99961 3.0001C6.55778 3.0001 6.19961 3.35827 6.19961 3.8001V7.0001C6.19961 7.44192 6.55778 7.8001 6.99961 7.8001C7.44144 7.8001 7.79961 7.44192 7.79961 7.0001V3.8001C7.79961 3.35827 7.44144 3.0001 6.99961 3.0001Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleRed);
export default __webpack_public_path__ + "static/media/exclamation-circle-red.95cbbcd85b879683488345199d7f2ed6.svg";
export { ForwardRef as ReactComponent };